export enum Claim {
    UserId = 'api.doeleman.nl.userId',
    UserName = 'api.doeleman.nl.userName',
    UserFullName = 'api.doeleman.nl.userFullName',
    CompanyName = 'api.doeleman.nl.companyName',
    CompanyId = 'api.doeleman.nl.companyId',
    Roles = 'api.doeleman.nl.role',
    Rights = 'api.doeleman.nl.right',
}
